import React from "react";
import { Button, Modal } from "react-bootstrap";
import { ActionHandlerFunction, AdminUser } from "@preveil-api";
import { Account, AdminErrorMessages, AdminSuccessMessages, AdminUIActionTypes, Message, MessageAnchors, MessageHandlerDisplayType, useAddOrganizationMembersMutation, useAppDispatch, useAppSelector } from "src/common";
import { UserInfoCard } from ".";
import { adminActions, uiActions } from "src/store";
import { RootState } from "src/store/configureStore";

type AllProps = {
  current_account: Account;
  show_modal: boolean;
  users: AdminUser[];
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleAction: ActionHandlerFunction;
};

function ResendInvitesModalComponent(props: AllProps) {
  const { show_modal, users, current_account, setShowModal, handleAction } = props;
  const dispatch = useAppDispatch();
  const org_info = useAppSelector((state: RootState) => state.account.organization);
  const [addOrganizationMembers] = useAddOrganizationMembersMutation();

  // Description: API for sending invites to external users.
  async function resendUsersInvites() {
    if (!!org_info) {
      const user_id = current_account.user_id;
      const org_id = org_info.org_id;
      await addOrganizationMembers({ orgId: org_id, userId: user_id, users })
        .unwrap()
        .then(() => {
          const success_message = AdminSuccessMessages.success_resend_invite_users.replace(MessageAnchors.message_content, `${users.length === 1 ? users[0].display_name : `${users.length} users`}`);
          dispatch(uiActions.handleSetMessage(new Message(success_message)));
          reset();
        })
        .catch((error) => {
          const error_message = AdminErrorMessages.error_resend_invite_users.replace(MessageAnchors.message_content, `${users.length === 1 ? users[0].display_name : users.length} users`);
          dispatch(uiActions.handleRequestErrors(new Message(error_message, MessageHandlerDisplayType.toastr), error));
          reset();
        });
    }
  }

  function reset() {
    setShowModal(false);
    handleAction({ actionType: AdminUIActionTypes.GetRefreshRequest });
    dispatch(adminActions.setSelected([]));
  }
  
  return <Modal size="lg" show={show_modal} onHide={() => setShowModal(false)} centered aria-label="Resend Invites">
    <Modal.Header closeButton>
      <Modal.Title>Resend Invites</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <h5 className="mb-3">Invites to be sent</h5>
      <UserInfoCard users={users} />
      <div className="btn-panel">
        <Button onClick={() => resendUsersInvites()}>Resend Invites</Button>
        <Button variant="no-outline-primary" onClick={() => setShowModal(false)}>Cancel</Button>
      </div>
    </Modal.Body>
  </Modal>;
}

export default React.memo(ResendInvitesModalComponent);
